import { HttpClient } from '@angular/common/http';
import { HttpClientService } from './http-client.service';
import { API_CONSTANT } from './api.constant';
import { Observable } from "rxjs/Observable";
import { catchError } from "rxjs/operators";
var ApiService = (function () {
    function ApiService(localHttp, http) {
        this.localHttp = localHttp;
        this.http = http;
    }
    ApiService.prototype.getErrorMessage = function (error) {
        if (error != null && error.error != null && error.error.message != null && error.error.message.length > 0)
            return error.error.message.join(',');
        else
            return ['Error, Please try again later', 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง'];
    };
    ApiService.prototype.createDownloadFile = function (blob, filename) {
        // for IE10+
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            var element = document.createElement('a');
            document.body.appendChild(element);
            var url = window.URL.createObjectURL(blob);
            element.setAttribute('href', url);
            element.setAttribute('download', filename);
            element.style.display = 'none';
            element.click();
            document.body.removeChild(element);
        }
    };
    ApiService.prototype.parseErrorBlob = function (err) {
        var reader = new FileReader();
        var obs = Observable.create(function (observer) {
            reader.onloadend = function (e) {
                try {
                    observer.error({ 'error': JSON.parse(reader.result) });
                }
                catch (e) {
                    observer.error({ 'error': null });
                }
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    };
    ApiService.prototype.updatePassword = function (newPassword) {
        return this.http.patch(API_CONSTANT.set_password, newPassword);
    };
    ApiService.prototype.uploadCSV = function (document) {
        return this.http.post(API_CONSTANT.upload_csv, document);
    };
    ApiService.prototype.signSignature = function (document) {
        return this.http.postBlob(API_CONSTANT.sign_docs, document).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBackgroundJobStatus = function (id) {
        return this.http.get(API_CONSTANT.background_jobs + id + '/');
    };
    ApiService.prototype.getTaxDataResult = function (data, params) {
        var url = API_CONSTANT.tax_data_upload_result;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postDownloadFile = function (data) {
        return this.http.post(API_CONSTANT.mark_download, data);
    };
    ApiService.prototype.postSummary = function (data) {
        return this.http.post(API_CONSTANT.summary_csv, data);
    };
    ApiService.prototype.getSalesTaxReport = function (data) {
        return this.http.postBlob(API_CONSTANT.sales_tax_report, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getZip2MB = function (data) {
        return this.http.postBlob(API_CONSTANT.zip_file_two_megabyte, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getZip = function (data) {
        return this.http.getBlob(API_CONSTANT.zip_file, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getFileFullPath = function (full_path) {
        return this.http.getBlob(full_path).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.postSearch = function (data, params) {
        var url = API_CONSTANT.search_files;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postSearch1 = function (data, params) {
        return this.postSearch(data, params);
    };
    ApiService.prototype.sign_counter = function (data, params) {
        return this.http.post(API_CONSTANT.sign_counter + '?' + params, data);
    };
    ApiService.prototype.getUsers = function (params) {
        return this.http.get(API_CONSTANT.users, params);
    };
    ApiService.prototype.createUser = function (data) {
        return this.http.post(API_CONSTANT.users, data);
    };
    ApiService.prototype.updateUser = function (data) {
        return this.http.patch(API_CONSTANT.users + data.id + '/', data);
    };
    ApiService.prototype.deleteUser = function (data) {
        return this.http.delete(API_CONSTANT.users + data.id + '/');
    };
    ApiService.prototype.getGroups = function (params) {
        return this.http.get(API_CONSTANT.groups, params);
    };
    ApiService.prototype.getMe = function (params) {
        return this.http.get(API_CONSTANT.me, params);
    };
    ApiService.prototype.getDashboardMonthlyData = function (data) {
        return this.http.get(API_CONSTANT.dashboard_monthly, data);
    };
    ApiService.prototype.getDashboardSignCounterMinute = function (data) {
        return this.http.get(API_CONSTANT.dashboard_sign_counter_minute, data);
    };
    ApiService.prototype.getDashboardLengthData = function (data) {
        return this.http.get(API_CONSTANT.dashboard_length, data);
    };
    ApiService.prototype.getDashboardActivity = function (data) {
        return this.http.get(API_CONSTANT.dashboard_activity, data);
    };
    ApiService.prototype.getCompany = function () {
        return this.http.get(API_CONSTANT.corporates);
    };
    ApiService.prototype.getUserId = function () {
        return this.http.get(API_CONSTANT.groups);
    };
    ApiService.prototype.getCompanyGroup = function () {
        return this.http.get(API_CONSTANT.group_corporates);
    };
    ApiService.prototype.getBranch = function () {
        return this.http.get(API_CONSTANT.branches);
    };
    ApiService.prototype.getDocumentType = function () {
        return this.http.get(API_CONSTANT.document_type);
    };
    ApiService.prototype.postSaleTax = function (data, params) {
        var url = API_CONSTANT.sales_tax_view;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postBulkSaleTax = function (data, params) {
        var url = API_CONSTANT.bulk_sales_tax_view;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.getBulkMissingDoc = function (params) {
        return this.http.getBlob(API_CONSTANT.export_bulk_missing_excel, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBulkAllDocs = function (params) {
        return this.http.getBlob(API_CONSTANT.export_bulk_all_docs, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.postSaleZipTax = function (data, params) {
        var url = API_CONSTANT.sales_zip_tax;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.getMissingDoc = function (params) {
        return this.http.getBlob(API_CONSTANT.export_missing_excel, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.approveSale = function (params) {
        return this.http.post(API_CONSTANT.approve_sale_tax, params);
    };
    ApiService.prototype.approveUploadSale = function (params) {
        return this.http.post(API_CONSTANT.approve_upload_sale, params);
    };
    ApiService.prototype.getAllDocs = function (params) {
        return this.http.getBlob(API_CONSTANT.export_all_docs, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.downloadFileFromMediaPath = function (url) {
        return this.http.getBlob(API_CONSTANT.MEDIA_PATH_URL + url).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getAllZipFile = function (params) {
        return this.http.postBlob(API_CONSTANT.export_zip_file, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getExcelReport = function (params) {
        return this.http.getBlob(API_CONSTANT.export_monthly_excel_report, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBuyer = function (params) {
        return this.http.get(API_CONSTANT.buyer, params);
    };
    ApiService.prototype.postB2PDocumentSummary = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.postB2PDocumentSummaryDetail = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary_detail;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.downloadB2PDocumentSummaryDetailExcel = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary_detail_excel;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.postBlob(url, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBillingExcelReport = function (params) {
        return this.http.getBlob(API_CONSTANT.export_billing_monthly_excel_report, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.sendEmail = function (data) {
        return this.http.post(API_CONSTANT.send_email, data);
    };
    ApiService.prototype.getEmailReport = function (params) {
        return this.http.get(API_CONSTANT.email_report, params);
    };
    ApiService.prototype.getEmailDashboard = function (params) {
        return this.http.get(API_CONSTANT.email_report, params);
    };
    return ApiService;
}());
export { ApiService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/api.service.ts.pre-build-optimizer.js